module.exports = __webpack_public_path__ + "img/slim36.ee9cfaa5.jpg";